(() => {
  function setup(scope = document) {
    scope.querySelectorAll('[data-bb-product]').forEach(stage => {
      if (stage.dataset.bbReady) return;
      stage.dataset.bbReady = 'true';
      const show = id => {
        const panes = [...stage.querySelectorAll('[data-bb-media]')];
        if (!panes.some(pane => pane.dataset.bbMedia === String(id))) return;
        panes.forEach(pane => {
          pane.hidden = pane.dataset.bbMedia !== String(id);
          if (pane.hidden) pane.querySelectorAll('video').forEach(video => video.pause());
        });
        stage.querySelectorAll('[data-bb-media-target]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.bbMediaTarget === String(id))));
      };
      stage.querySelectorAll('[data-bb-media-target]').forEach(button => button.addEventListener('click', () => show(button.dataset.bbMediaTarget)));
      const connectVariants = () => {
        if (window._ThemeEvent?.subscribe) {
          stage.bbUnsubscribe = window._ThemeEvent.subscribe(`${stage.dataset.bbProduct}__VARIANT_CHANGE`, variant => {
            if (variant?.featured_media?.id) show(variant.featured_media.id);
          });
        }
      };
      if (document.readyState === 'complete') connectVariants();
      else window.addEventListener('load', connectVariants, {once: true});
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-bb-product]').forEach(stage => stage.bbUnsubscribe?.()));
})();
